<template>
  <div class="contant d-flex flex-column" :class="{ mobile: isMobile }">
    <div class="font-42 mt-lg-16 mt-5">Explore, innovate,</div>
    <div class="font-42">and build the future of Web3 on Uptick!</div>
    <div class="font-20 mt-5">Here, you can learn everything about building on the Uptick Network, including infrastructure modules, protocols, middleware, tools, and how to create innovative Web3 applications.</div>
    <div class="doc d-flex flex-lg-row  flex-column">
      <div class="item mr-8 d-flex flex-column align-center ">
        <img   class="iconImg" src="@/assets/icon_001.png" />
        <div class="itemTitle mt-10" >Knowledge Base</div>
      
        <div class="itemDesc mt-5">This documentation provides a comprehensive overview of the working principles, protocol rules, and data structure of the Uptick Chain. It offers developers, validators, delegators, and users of all kinds with the essential knowledge and guidance for understanding and utilizing the chain effectively.<br/>
          <a href="https://upticknft.gitbook.io/uptick-network-documentation" target="_blank" class="viewDoc">View Doc ></a>
        </div>
        <!-- <button class="dovBtn">View Doc</button> -->

      </div>
      <div class="item mr-8 d-flex flex-column align-center ">
        <img   class="iconImg" src="@/assets/icon_002.png" />
        <div class="itemTitle mt-10">Developer Guide</div>
        <div class="itemDesc mt-5">This documentation is specifically designed for full-stack developers, offering detailed information on developing, customizing, and operating the Uptick Chain. It empowers developers by providing them with the extensive knowledge and tools needed to build, deploy, and maintain their own blockchain applications, services, and tools on the Uptick infrastructure.<br/>
          <a href="https://upticknft.gitbook.io/uptick-developer-documentation" target="_blank" class="viewDoc">View Doc ></a>
        </div>
       
      </div>
      <div class="item d-flex flex-column align-center">
        <img   class="iconImg" src="@/assets/icon_003.png" />
        <div class="itemTitle mt-10">Web3 Application Developer Hub</div>
        <div class="itemDesc mt-5">The Web3 Application Developer Hub is an all-in-one solution for Web3 developers. If your primary focus is on developing client-side application-specific logics, user interfaces, and flows without prior blockchain and middleware development experience, this is the perfect place to begin your journey.
          Here, you can find extensive documentation, tutorials, samples, and various services to facilitate a quick understanding and enable you to get up to speed and start developing Web3 applications with ease.<br/>
          <a href="https://upticknft.gitbook.io/web3_application_developer_hub" target="_blank" class="viewDoc">View Doc ></a>
        </div>

          <div class="d-flex flex-row" style="width: 100%;align-items: center;justify-content: center;">
        
            <button class="applyBtn-1 ml-4" @click="toApply">Apply for API Key</button>
          </div>
      

      </div>

    </div>
    <uComponents ref="ucom"></uComponents>
  </div>
</template>

<script>

export default {
  name: "Home",
  components: {},
  data: function () {
    return {
     
    };
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile;
    },
  },

  async mounted() {
    
   

   
  },
  methods: {
    toApply(){
      let isLogin =  localStorage.getItem('Authorization')
     if(isLogin){
      this.$router.push({ name: "myInfo",query:{"source":'user'} });
     }else{
      this.$router.push({ name: 'Login' })

     }
    }
   
  
 
  },
};
</script>

<style lang="scss" scoped>
.contant {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .font-42{
   
    font-family: AvenirNext-Bold;
	font-size: 42px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 60px;
	letter-spacing: 0px;
	color: #ffffff;
  text-align: center;
  }
  .font-20{
    width: 80%;
    font-family: AvenirNext-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 30px;
	color: #ffffff;
  text-align: center;
  }
  .viewDoc{

    font-family: AvenirNext-Medium;
	font-size: 16px;
	font-weight: 600;
	font-stretch: normal;
	line-height: 40px;
	letter-spacing: 0px;

  color:#a443f6;
  text-decoration: none;
  &:hover{
    color: #ffffff;
   
  }
  }
 
  .doc{
    width: 100%;
    margin-top: 50px;
  
    .item{
      position: relative;
      padding:40px 30px 0;
      width: 32%;
      min-height: 520px;
      background-color: rgba(0, 0, 0, 0.3);
  border-radius: 15px;
    border-style: solid;
    border-width: 2px;
    border-color: rgba(255, 112, 74, 0.3);



  .iconImg{
    width: 84px;
    height: 84px;
  }
  .itemTitle{
    font-family: AvenirNext-Bold;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	color: #ff704a;
  }
  .itemDesc{
    min-height: 200px;
    font-family: AvenirNext-Medium;
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	letter-spacing: 0px;
	color: #ffffff;
  text-align: center;
  }
  .dovBtn{
    margin-top:25px;
   margin-bottom: 25px;
    width: 146px;
	height: 46px;
	background-color: #a443f6;
	border-radius: 5px;
  font-family: AvenirNext-Medium;
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	letter-spacing: 0px;
	color: #ffffff;
  }
  .applyBtn{
    margin-top:25px;
   margin-bottom: 25px;
padding: 0 30px;
	height: 46px;
	background-color: #a443f6;
	border-radius: 5px;
  font-family: AvenirNext-Medium;
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	letter-spacing: 0px;
	color: #ffffff;

  }
  .applyBtn-1{
    width: 80%;
    margin-top:25px;
   margin-bottom: 25px;
padding: 0 30px;
	height: 46px;
  font-family: AvenirNext-Medium;
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 20px;
	letter-spacing: 0px;
	color: #ffffff;

    background-image: linear-gradient(128deg, 
		#b734ee 0%, 
		#ff704a 100%);
	border-radius: 5px;

  }

    }
  }
  &.mobile {
    .font-42{
      
      font-size: 30px;
      line-height: 40px;
    }
    .font-20{
      width: 80%;

    }
    .name {
      width: 80%;
    }
    .passwd {
      width: 80%;
    }
    .doc{

      .item{
        min-height: 100px;
        margin-bottom: 10px;
        width: 100%;
      }
      .itemDesc{
        min-height: 100px;
        
        margin-bottom: 30px;
      }
      .applyBtn-1{
        margin-top: 0px;
      }
    }
  }
}
</style>

